export const Tags = {
	page: "page",
	faqItem: "faq",
	faqCategory: "faq-category",
	emergencyBanner: "emergency-banner",
	home: "home",
	form: "form",
	pipelineMap: "pipeline",
	404: "404",
	navigation: "navigation",
};

export const ALL_CATEGORY = "all";

export const acceptedFiles = [
	"application/pdf",
	"image/png",
	"image/jpeg",
	"image/jpg",
	"image/heic",
];

export const siteURL =
	process.env.NEXT_PUBLIC_SITE_URL || "https://" + process.env.NEXT_PUBLIC_VERCEL_URL;
export const siteAPIURL = siteURL + "/api";
